<template>
  <div class="row pl-4">
    <div class="col-md-3 col-sm-12">
      <span class="data-title d-block border-mobile">Número de Voucher:</span>
      <span class="font-16 color-black">
        {{ billPayment.voucherNumber }}
      </span>
    </div>
    <div class="col-md-3 col-sm-12">
      <span v-if="billPayment.isAch" class="data-title d-block border-mobile">
        Número de ACH:
      </span>
      <span v-else class="data-title d-block border-mobile">
        Número de Cheque:
      </span>
      <span class="font-16 color-black">
        {{ billPayment.paymentIdReference | empty }}
      </span>
    </div>
    <div class="col-md-2 col-sm-12 border-right">
      <span class="data-title d-block border-mobile">Fecha de Pago:</span>
      <span class="font-16 color-black">
        {{ billPayment.paymentDate | date }}
      </span>
    </div>

    <div class="col-md-3 col-sm-12">
      <div class="d-flex justify-content-end align-items-center">
        <div style="width: 60px; height: 60px">
          <circle-loader
            v-if="paymentPercentage < 100"
            circle-class="custom-circle-loader"
            :percentage="paymentPercentage"
          />
          <i v-else class="fas fa-check-circle fa-3x green-color pt-3" />
        </div>
        <div class="ml-2 mt-2">
          <div class="color-secondary-6 font-14">
            Monto Total:
          </div>
          <div>
            <div>
              <span class="color-green font-weight-bold font-22">
                {{ billPayment.purchaseTotal | price }}
              </span>
              /
              <span class="color-secondary-6 font-16">
                {{ billPayment.billingTotal | price }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircleLoader from '@/components/common/loaders/CircleLoader';
import { getPaymentDetail as _getPaymentDetail } from '@/services/provider/billing-history.api.js';

export default {
  name: 'BillingHistoryDetail',
  components: {
    CircleLoader,
  },
  props: {
    billId: {
      type: Number,
      default: () => 0,
    },
  },
  data: () => ({
    billPayment: {
      voucherNumber: null,
      paymentIdReference: null,
      paymentDate: null,
      purchaseTotal: null,
      billingTotal: null,
    },
  }),
  computed: {
    paymentPercentage() {
      return (
        (this.billPayment.purchaseTotal / this.billPayment.billingTotal) * 100
      );
    },
  },
  async mounted() {
    await this.getPaymentDetail();
  },
  methods: {
    async getPaymentDetail() {
      const { data } = await _getPaymentDetail(this.billId);

      this.billPayment = data[0];
    },
  },
};
</script>

<style scoped lang="scss">
.green-color {
  color: #2db782;
}
</style>
